import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import OPDashboard from './pages/OPDashboard';
import PublicLandingPage from './pages/PublicLandingPage';
import AgentConfirmationPage from './pages/AgentConfirmationPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AgentDashboard from './pages/AgentDashboard';
import PendingConsent from './pages/PendingConsent';
import ConsentGuard from './components/ConsentGuard';

function PrivateRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-slate-900">
      <div className="text-xl text-gray-900 dark:text-white">Se încarcă...</div>
    </div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/admin/*"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <ConsentGuard>
                <AdminDashboard />
              </ConsentGuard>
            </PrivateRoute>
          }
        />

        <Route
          path="/op/*"
          element={
            <PrivateRoute allowedRoles={['op', 'cso', 'retea', 'regiune', 'manager']}>
              <ConsentGuard>
                <OPDashboard />
              </ConsentGuard>
            </PrivateRoute>
          }
        />

        <Route
          path="/agent/*"
          element={
            <PrivateRoute allowedRoles={['agent']}>
              <ConsentGuard>
                <AgentDashboard />
              </ConsentGuard>
            </PrivateRoute>
          }
        />

        <Route path="/pending-consent" element={<PendingConsent />} />

        {/* Route PUBLIC - fără autentificare */}
        <Route path="/lp/:slug" element={<PublicLandingPage />} />
        <Route path="/confirmare-agent/:token" element={<AgentConfirmationPage />} />
        <Route path="/politica-confidentialitate" element={<PrivacyPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* OP Profile Route - Nested under /op in dashboard or standalone? */}
        {/* Since OPDashboard handles sub-routes, we should add it there OR add a standalone protected route */}
        {/* Let's add it as a standalone protected route for simplicity or check OPDashboard routing */}

        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppRoutes />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
